import InnerBlocks from '../InnerBlocks';
import React, { Component, Fragment } from 'react';
import './style.scss';
class PageSection extends Component {
  constructor(){
    super()
    this.state = {}
  }

  content = contentBlocks => <InnerBlocks blocks={ contentBlocks } />

  render(){
    // Get the variables
    const { data } = this.props
    
    // Generate classes
    let classes = ['page_section']
    if (data.has_color_scheme) {
      classes.push('has-colorscheme')
    }
    if ( data.small_image) {
      classes.push('has-image')
    }
    classes = classes.join(' ')
    
    // Generate the inline styles
    const styles = {}

    if (data.background_image) {
      styles.backgroundImage = `url(${data.background_image})`
    }

    // Display the result
    return(
      <section
        className={classes}
        style={styles}
      >
        { !data.small_image && this.content(data.page_content_panel) }
        { data.small_image && 
          <Fragment>
            <div className="content_container">
              {this.content(data.page_content_panel)}
            </div>
            <div className="image_container">
              <img className="hero_image" src={ data.small_image } alt="" role="presentation" />
            </div>
          </Fragment>
        }
      </section>
    )
  }
}

export default PageSection